import React from 'react';
import styled from 'styled-components';
import { pmWhite } from '../sharedData/Constants';
import MobileBreakLine from '../components/MobileBreakLine';
import DeskBreakLine from '../components/DeskBreakLine';

import { MobileWidth } from '../sharedData/Constants';
import DownloadButton from './DownloadButton';


const DownloadStudy = () => {
    return(
        <StyledView>
            <Title>
                Quer saber mais sobre esses conteúdos e outras<MobileBreakLine/> tendências para essa Black Friday? 
            </Title>
            <Subtitle>
                Baixe o estudo completo<MobileBreakLine/> com todos<DeskBreakLine/> os insights para<MobileBreakLine/> 2024.
            </Subtitle>
            <DownloadButton/>
        </StyledView>
    );
};

const Title = styled.div`
    font-size: 24px;
    color: ${pmWhite};
    text-align: center;
    @media screen and (max-width: ${MobileWidth}){
        font-size: 12px;
    }
`

const Subtitle = styled.div`
    margin-top: 27px;
    font-size: 48px;
    font-weight: bold;
    color: ${pmWhite};
    text-align: center;
    @media screen and (max-width: ${MobileWidth}){
        font-size: 24px;
    }
`

const StyledView = styled.div` 
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

export default DownloadStudy;